export const WHATSAPP_NUMBER = "12605687097";
export const whatsappLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
export const WA_DEFAULT = whatsappLink(
  "Hello TEAM X, I would like to learn more about your educational consultation services."
);
export const WA_PROMO = whatsappLink(
  "Hello TEAM X, I want to claim the 50% OFF consultation promotion."
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1580446623001-3abf670c5c55?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroAlt: "https://images.unsplash.com/photo-1769674154615-0cd4f99f9945?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxyZWQlMjBzcG9ydHMlMjBjYXIlMjBuaWdodCUyMGNpdHklMjBuZW9ufGVufDB8fHx8MTc5MDc1MjEwOHww&ixlib=rb-4.1.0&q=85",
  aboutHq: "https://images.unsplash.com/photo-1522968941782-e27ac665baa3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBnbGFzcyUyMGFyY2hpdGVjdHVyYWwlMjB0ZWNoJTIwb2ZmaWNlfGVufDB8fHx8MTc5MDc1MjEwOHww&ixlib=rb-4.1.0&q=85",
  boardroom: "https://images.unsplash.com/photo-1497366412874-3415097a27e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBnbGFzcyUyMGFyY2hpdGVjdHVyYWwlMjB0ZWNoJTIwb2ZmaWNlfGVufDB8fHx8MTc5MDc1MjEwOHww&ixlib=rb-4.1.0&q=85",
};

export const COMPANIES = [
  {
    ticker: "TSLA",
    name: "Tesla, Inc.",
    category: "Electric Vehicles & Energy Tech",
    trend: "+4.8%",
    marketCap: "$780B",
    summary:
      "Tesla is widely recognized for advancements in electric vehicles, battery technology, and sustainable energy solutions. It is featured as an example of innovation within the technology and transportation sectors.",
    badge: "Flagship Example",
    focus: "FSD Neural Nets & Battery Ecosystem",
    image:
      "https://images.unsplash.com/photo-1682428586707-5ce1123e7d1e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    ticker: "NVDA",
    name: "Nvidia Corporation",
    category: "AI Compute & Semiconductors",
    trend: "+6.2%",
    marketCap: "$3.1T",
    summary:
      "Nvidia designs the accelerated computing platforms behind modern artificial intelligence, data centers, and advanced graphics — a core case study in the AI hardware revolution.",
    badge: "Core Foundation",
    focus: "Blackwell Silicon & CUDA Ecosystem",
    image:
      "https://images.unsplash.com/photo-1678957949479-b1e876bee3f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtaWNyb2NoaXAlMjBwcm9jZXNzb3IlMjBjaXJjdWl0fGVufDB8fHx8MTc5MDc1MjIyMnww&ixlib=rb-4.1.0&q=85",
  },
  {
    ticker: "MSFT",
    name: "Microsoft Corporation",
    category: "Cloud & Enterprise AI",
    trend: "+2.4%",
    marketCap: "$3.2T",
    summary:
      "Microsoft anchors enterprise cloud infrastructure through Azure and leads workplace AI adoption — an instructive example of platform-scale business model evolution.",
    badge: "Institutional Anchor",
    focus: "Azure AI & Global Data Centers",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnbGFzcyUyMHRlY2glMjBjYW1wdXMlMjBkYXRhY2VudGVyfGVufDB8fHx8MTc5MDc1MjEwOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    ticker: "AAPL",
    name: "Apple Inc.",
    category: "Consumer Tech & Edge AI",
    trend: "+1.9%",
    marketCap: "$3.4T",
    summary:
      "Apple combines proprietary silicon, design-led hardware, and a services ecosystem — a study in brand moats, supply-chain mastery, and on-device intelligence.",
    badge: "Ecosystem Leader",
    focus: "Apple Silicon & On-Device Neural",
    image:
      "https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxzZWVrJTIwYXBwbGUlMjBwaG9uZSUyMG1pbmVyaWFsJTIwZGFya3xlbnwwfHx8fDE3OTA3NTIxMDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    ticker: "AMZN",
    name: "Amazon.com, Inc.",
    category: "Cloud Infrastructure & Logistics",
    trend: "+3.1%",
    marketCap: "$1.9T",
    summary:
      "Amazon pairs AWS cloud dominance with automated global logistics — a case study in reinvestment flywheels and infrastructure-scale thinking.",
    badge: "Infra Giant",
    focus: "AWS Compute & Robotics Logistics",
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxkYXRhY2VudGVyJTIwc2VydmVyJTIwbGFzc3xlbnwwfHx8fDE3OTA3NTIyMjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    ticker: "GOOGL",
    name: "Alphabet Inc.",
    category: "Frontier AI & Search",
    trend: "+2.8%",
    marketCap: "$2.2T",
    summary:
      "Alphabet spans search, frontier AI research, and quantum computing — an educational lens on how moonshot portfolios sit beside cash-generating cores.",
    badge: "Frontier Research",
    focus: "Gemini Models & DeepMind Research",
    image:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBnbGFzcyUyMHRlY2glMjBjYW1wdXMlMjBkYXRhY2VudGVyfGVufDB8fHx8MTc5MDc1MjEwOHww&ixlib=rb-4.1.0&q=85",
  },
];

export const SERVICES = [
  {
    id: "investment-education",
    num: "01",
    title: "Investment Education",
    subtitle: "Structured Market Curricula",
    description:
      "Structured programs that build lasting market literacy — from asset classes and valuation fundamentals to portfolio construction principles used by professional desks.",
    tags: ["Curriculum", "Valuation Basics", "Portfolio Theory"],
  },
  {
    id: "market-research",
    num: "02",
    title: "Market Research",
    subtitle: "Noise-Filtered Intelligence",
    description:
      "Condensed, source-verified research briefs on macro trends, earnings cycles, and capital flows — delivered before the noise, not after it.",
    tags: ["Macro Briefs", "Earnings Radar", "Flow Analysis"],
  },
  {
    id: "tech-insights",
    num: "03",
    title: "Technology Sector Insights",
    subtitle: "Frontier Industry Mapping",
    description:
      "Deep-dive educational coverage of semiconductors, AI infrastructure, electric mobility, and the companies reshaping each value chain.",
    tags: ["Semiconductors", "AI Infrastructure", "EV Ecosystems"],
  },
  {
    id: "portfolio-guidance",
    num: "04",
    title: "Portfolio Guidance",
    subtitle: "Allocation Frameworks",
    description:
      "Educational frameworks for diversification, position sizing, and rebalancing discipline — helping learners structure their own decision process.",
    tags: ["Diversification", "Position Sizing", "Rebalancing"],
  },
  {
    id: "risk-awareness",
    num: "05",
    title: "Risk Awareness Education",
    subtitle: "Capital Preservation First",
    description:
      "Drawdown mechanics, volatility regimes, and behavioral risk traps — because understanding what you can lose matters more than what you can gain.",
    tags: ["Drawdown Math", "Volatility", "Behavioral Risk"],
  },
  {
    id: "global-analysis",
    num: "06",
    title: "Global Market Analysis",
    subtitle: "Cross-Border Perspective",
    description:
      "Educational analysis across US, European, and Asian markets — currencies, rates, and geopolitical catalysts that move global capital.",
    tags: ["FX & Rates", "Geopolitics", "Global Indices"],
  },
];

export const TESTIMONIALS = [
  {
    name: "Marcus Vance",
    role: "Chief Investment Officer, Vance Meridian Capital",
    location: "Zurich / London",
    quote:
      "TEAM X dismantled our conventional allocation biases. Their educational frameworks on the semiconductor cycle gave our research team a genuinely sharper lens.",
    aum: "$42M Managed",
    initials: "MV",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBleGVjdXRpdmUlMjBoZWFkc2hvdCUyMGZpbmFuY2V8ZW58MHx8fDE3OTA3NTIxMDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Dr. Aris Thorne",
    role: "Former Quant Lead & Managing Partner",
    location: "Singapore",
    quote:
      "The curriculum bridges institutional microstructure and macroeconomic clarity. Completely devoid of retail noise — pure, structured, actionable education.",
    aum: "$18M Portfolio",
    initials: "AT",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBleGVjdXRpdmUlMjBoZWFkc2hvdCUyMGZpbmFuY2V8ZW58MHx8fDE3OTA3NTIxMDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Elena Rostova",
    role: "Tech Founder & Family Office Trustee",
    location: "New York / Geneva",
    quote:
      "Consulting with TEAM X gave our family office the conviction to understand AI infrastructure before committing capital. Rigorous, patient, and precise.",
    aum: "$65M Family Office",
    initials: "ER",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBleGVjdXRpdmUlMjBoZWFkc2hvdCUyMGZpbmFuY2V8ZW58MHx8fDE3OTA3NTIxMDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "David K. Chen",
    role: "VP of Engineering & Angel Investor",
    location: "San Francisco",
    quote:
      "The WhatsApp advisory desk operates with remarkable speed. Their risk-awareness module alone changed how I size every position I take.",
    aum: "Private Angel Desk",
    initials: "DC",
    avatar:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBleGVjdXRpdmUlMjBoZWFkc2hvdCUyMGZpbmFuY2V8ZW58MHx8fDE3OTA3NTIxMDh8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const RISK_POINTS = [
  "All investments carry risk.",
  "Capital is at risk.",
  "Returns are not guaranteed.",
  "Past performance is not indicative of future results.",
  "Market conditions can change rapidly.",
  "Users should make independent financial decisions.",
  "TEAM X provides educational information and consultation services only.",
];

export const TICKER_SEED = [
  { symbol: "TSLA", price: 248.42, change_pct: 4.8 },
  { symbol: "NVDA", price: 131.88, change_pct: 6.2 },
  { symbol: "AAPL", price: 227.52, change_pct: 1.9 },
  { symbol: "MSFT", price: 428.15, change_pct: 2.4 },
  { symbol: "AMZN", price: 186.33, change_pct: 3.1 },
  { symbol: "GOOGL", price: 175.98, change_pct: 2.8 },
  { symbol: "SPX", price: 5472.1, change_pct: 0.6 },
  { symbol: "NDX", price: 19755.4, change_pct: 1.1 },
];

export const BOOKING_SLOTS = ["09:00", "10:00", "11:00", "12:00", "14:00", "15:00", "16:00", "17:00"];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
